import { Routes } from '@angular/router';
import { createAuthGuard } from '@core/auth';
import { userRightsLoaderGuard } from '@core/user';
import { AuthenticatedLayoutComponent } from './authenticated-layout.component';
import { AppShellComponent } from './app/app-shell.component';
import { impersonationGuard } from '../features/support/impersonation/impersonation.guard';

export const ROOT_ROUTES: Routes = [
  {
    path: 'signin-callback',
    loadComponent: () =>
      import('@core/auth/oauth/signin-callback.component').then(
        (m) => m.SigninCallbackComponent
      ),
  },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivate: [createAuthGuard()],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'app',
      },
      {
        path: 'impersonate',
        title: 'Impersonierung',
        loadComponent: () =>
          import('../features/support/impersonation/impersonation-page.component').then(
            (m) => m.ImpersonationPageComponent
          ),
        canActivate: [impersonationGuard],
      },
      {
        path: 'unavailable',
        title: 'Server nicht erreichbar',
        loadComponent: () =>
          import('@core/error-handling/components').then(
            (m) => m.ServerUnavailablePageComponent
          ),
      },
      {
        path: 'app',
        component: AppShellComponent,
        canActivate: [userRightsLoaderGuard],
        loadChildren: () =>
          import('./app/app.routes').then((m) => m.APP_ROUTES),
      },
    ],
  },
];
